export default __webpack_public_path__ + "static/media/facebook.02e36429.svg";